import dayjs from 'dayjs';

import type { ClosingPeriodType } from 'app/typings/core/admin/experiences/closingPeriod/closingPeriod';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';

import { isDayClosedByOpeningHours } from './openingHours';

const isWithinClosingPeriod = (
  closingPeriods: ClosingPeriodType[] | undefined,
  date: Date
): boolean => {
  const day = dayjs(date).startOf('day');

  return (closingPeriods ?? []).some((period) => {
    const start = dayjs(period.start).startOf('day');
    const end = dayjs(period.end).startOf('day');

    return !day.isBefore(start) && !day.isAfter(end);
  });
};

const isWithinLastMinuteWindow = (
  closedDaysBeforeCheckIn: number | undefined,
  date: Date
): boolean => {
  if (!closedDaysBeforeCheckIn) {
    return false;
  }

  const limit = dayjs().startOf('day').add(closedDaysBeforeCheckIn, 'day');

  return dayjs(date).startOf('day').isBefore(limit);
};

export const isDayFullyClosed = (
  experience: ExtranetHotelExperience | undefined,
  date: Date
): boolean => {
  if (!experience) {
    return false;
  }

  return (
    isDayClosedByOpeningHours(experience.openingHours, date) ||
    isWithinClosingPeriod(experience.closingPeriods, date) ||
    isWithinLastMinuteWindow(experience.closedDaysBeforeCheckIn, date)
  );
};
